import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class TeamPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.teamRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.teamImport,
    );
    this.teamAutocomplete = permissionChecker.match(
      Permissions.values.teamAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.teamCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.teamEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.teamDestroy,
    );
  }
}
